export default __webpack_public_path__ + "static/media/lightSmileLogo.62606997.svg";